import { default as deserialize } from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch } from 'app/utils/data'

const initialState = () => ({
  list: []
})

export default {
  namespaced: true,

  state: initialState(),

  mutations: {
    pageviewDomainsFetched(state, { pageviewDomains }) {
      state.list = pageviewDomains
    },

    // Required by sessions/resetEverything: that action iterates every
    // top-level Vuex module and commits `<module>/resetState` to clear
    // per-session state after sign-out or account deletion. Without this
    // mutation Vuex logs "unknown mutation type" warnings during the
    // deletion teardown. Restores `list` to its initial empty state.
    resetState(state) {
      Object.assign(state, initialState())
    }
  },

  actions: {
    async fetchPageviewDomains({ commit }, id) {
      try {
        const response = await fetch({ url: `/api/clouds/kits/pageview-domains/${id}` })

        const pageviewDomains = await deserialize(response.data)

        commit('pageviewDomainsFetched', { pageviewDomains })

        return pageviewDomains
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async fetchAggregatePageviewDomains({ commit }, { year, month } = {}) {
      try {
        let url = `/api/clouds/kits/pageview-domains`
        if (year && month) {
          url += `?year=${year}&month=${month}`
        }
        const response = await fetch({ url })

        const pageviewDomains = await deserialize(response.data)

        return pageviewDomains
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
